<template>
  <div class="modal-content">
    <img src="@images/icon/ico_logo.png" alt="" height="142" width="142">
    <p class="modal-title" v-html="$t('connect.text002')" />
    <ul class="text-list">
      <li class="text-item" v-html="$t('connect.text003')" />
      <li class="text-item" v-html="$t('connect.text004')" />
      <li class="text-item" v-html="$t('connect.text005')" />
    </ul>
    <a class="button" :class="[this.$route.params.lang]" v-html="$t('connect.btn001')" :href="`/login?url=${redirectUrl}`" />
    <div class="link-about-wrapper">
      <a
        href="https://my.nintendo.com/getting_started"
        target="_blank"
        class="link-about"
        v-html="$t('connect.text006')"
        @click="sendGaEvent()"
      />
    </div>
    <div class="button" :class="[this.$route.params.lang]" v-html="$t('connect.btn002')" @click="clickWithoutLogin()"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import localeModal from '@locales/modal'
export default {
  name: 'modal-na-link',
  $messages: localeModal,
  computed: {
    ...mapState('modal', ['modal']),
    redirectUrl() {
      return this.modal.props.redirectTo
    }
  },
  methods: {
    ...mapActions('modal', ['hideModal', 'showModal']),
    clickWithoutLogin() {
      if(this.modal.props.isModal){
        this.showModal(this.modal.props.withoutLogin)
      } else {
        this.$router.push(this.modal.props.withoutLogin)
        window.scrollTo(0, 0)
        this.hideModal()
      }
    },
    sendGaEvent(){
      this.$ga.event({
        eventCategory: 'click',
        eventAction: 'link_mynintendo',
        eventLabel: 'ellection',
        eventValue: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  padding-top: 80px;
  text-align: center;
}
.modal-title {
  font-size: $fs-xlarge;
  text-shadow: $ts-base;
  width: 460px;
  margin: 16px auto;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(~@images/modal/btn_general.png);
  background-repeat: no-repeat;
  background-size: 500px 113px;
  width: 500px;
  height: 113px;
  font-size: 2.2rem;
  text-shadow: $ts-base;
  margin: 0 auto;
  @include tap-event();
  &.ja-JP,
  &.zh-TW {
    font-size: 3rem;
  }
}
.text-list {
  width: 460px;
  margin: 0 auto 20px;
  text-align: left;
}
.text-item {
  font-size: $fs-large;
  text-shadow: $ts-base;
  padding-left: 40px;
  position: relative;
  &:before {
    content: '';
    display: inline-block;
    background-image: url(~@images/icon/ico_bullet.png);
    background-repeat: no-repeat;
    background-size: 20px 20px;
    background-position: 0 8px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
  }
}
.link-about-wrapper {
  margin: 10px 0 20px;
}
.link-about {
  padding-left: 40px;
  position: relative;
  color: #fff;
  text-shadow: $ts-base;
  font-size: $fs-middle;
  &:before {
    content: '';
    display: inline-block;
    background-image: url(~@images/icon/ico_arrow.png);
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 40px;
    height: 29px;
  }
}
</style>
